import axios from 'axios';

const createEmail = email => axios.post(`emails`, email);

const updateEmail = ({ id, ...email }) => axios.put(`emails/${id}`, email);

const deleteEmail = id => axios.delete(`emails/${id}`);

export { createEmail, updateEmail, deleteEmail };
